import gql from 'graphql-tag';

export const GET_DESTINATIONS = gql`
  query($url: String!) {
    destinationLinks(url: $url) {
        regionId
        anchor
        url
        subList {
          regionId
          anchor
          url
        }
      }
  }
`;
